// Provincias de España (id INE de 2 dígitos + nombre).
// Extraído como util compartido; otros archivos mantienen su copia inline
// (no se refactorizan para no arriesgar regresiones).
export const PROVINCIAS_ES = [
  { id: "01", nombre: "Álava" }, { id: "02", nombre: "Albacete" }, { id: "03", nombre: "Alicante" },
  { id: "04", nombre: "Almería" }, { id: "05", nombre: "Ávila" }, { id: "06", nombre: "Badajoz" },
  { id: "07", nombre: "Baleares" }, { id: "08", nombre: "Barcelona" }, { id: "09", nombre: "Burgos" },
  { id: "10", nombre: "Cáceres" }, { id: "11", nombre: "Cádiz" }, { id: "12", nombre: "Castellón" },
  { id: "13", nombre: "Ciudad Real" }, { id: "14", nombre: "Córdoba" }, { id: "15", nombre: "A Coruña" },
  { id: "16", nombre: "Cuenca" }, { id: "17", nombre: "Girona" }, { id: "18", nombre: "Granada" },
  { id: "19", nombre: "Guadalajara" }, { id: "20", nombre: "Guipúzcoa" }, { id: "21", nombre: "Huelva" },
  { id: "22", nombre: "Huesca" }, { id: "23", nombre: "Jaén" }, { id: "24", nombre: "León" },
  { id: "25", nombre: "Lleida" }, { id: "26", nombre: "La Rioja" }, { id: "27", nombre: "Lugo" },
  { id: "28", nombre: "Madrid" }, { id: "29", nombre: "Málaga" }, { id: "30", nombre: "Murcia" },
  { id: "31", nombre: "Navarra" }, { id: "32", nombre: "Ourense" }, { id: "33", nombre: "Asturias" },
  { id: "34", nombre: "Palencia" }, { id: "35", nombre: "Las Palmas" }, { id: "36", nombre: "Pontevedra" },
  { id: "37", nombre: "Salamanca" }, { id: "38", nombre: "S.C. Tenerife" }, { id: "39", nombre: "Cantabria" },
  { id: "40", nombre: "Segovia" }, { id: "41", nombre: "Sevilla" }, { id: "42", nombre: "Soria" },
  { id: "43", nombre: "Tarragona" }, { id: "44", nombre: "Teruel" }, { id: "45", nombre: "Toledo" },
  { id: "46", nombre: "Valencia" }, { id: "47", nombre: "Valladolid" }, { id: "48", nombre: "Vizcaya" },
  { id: "49", nombre: "Zamora" }, { id: "50", nombre: "Zaragoza" }, { id: "51", nombre: "Ceuta" },
  { id: "52", nombre: "Melilla" },
];

export function provinciaIdPorNombre(nombre) {
  if (!nombre) return "";
  const n = String(nombre).trim().toLowerCase();
  const p = PROVINCIAS_ES.find((x) => x.nombre.toLowerCase() === n);
  return p?.id || "";
}

/** Acepta id INE ("03"), "3" o nombre ("Alicante") → nombre para <select>. */
export function provinciaNombreDesdeValor(val) {
  if (val == null || val === "") return "";
  const s = String(val).trim();
  if (!s) return "";
  if (/^\d{1,2}$/.test(s)) {
    const id = s.padStart(2, "0");
    return PROVINCIAS_ES.find((p) => p.id === id)?.nombre || s;
  }
  const byName = PROVINCIAS_ES.find((p) => p.nombre.toLowerCase() === s.toLowerCase());
  return byName?.nombre || s;
}
